import type { ReactNode } from 'react';
import clsx from 'clsx';
import { Badge } from '@monksflow/monks-ui';

export interface CommentPillProps {
  variant?: 'default' | 'warning';
  testId: string;
  ariaLabel: string;
  icon?: ReactNode;
  label?: string;
  className?: string;
}

export function CommentPill({
  variant = 'default',
  testId,
  ariaLabel,
  icon,
  label,
  className,
}: CommentPillProps) {
  // eslint-disable-next-line i18next/no-literal-string -- Badge variant names from the design system
  const badgeVariant = variant === 'warning' ? 'warning' : 'secondary';

  return (
    <Badge
      variant={badgeVariant}
      data-testid={testId}
      aria-label={ariaLabel}
      className={clsx('select-none', className)}
    >
      {icon}
      {label && <span>{label}</span>}
    </Badge>
  );
}
